import { ArrowRight, Building2, Loader2 } from "lucide-react";
import { OrganizacaoEmFoco } from "./OrganizacaoEmFoco";
import { PainelEquipe } from "./PainelEquipe";
import { PainelPacientes } from "./PainelPacientes";
import { PainelAgenda } from "./PainelAgenda";
import { PainelProtese } from "./PainelProtese";
import { PainelPedidosDoLab } from "./PainelPedidosDoLab";
import type { PainelChave } from "./painel-tipos";
import type { PrazoDoLaboratorio } from "@bookdental/schemas";

const TITULO: Record<PainelChave, string> = {
  equipe: "Equipe",
  pacientes: "Pacientes",
  agenda: "Agenda",
  protese: "Pedidos de prótese",
  pendentes: "Pedidos pendentes",
  producao: "Em produção",
  atrasados: "Atrasados",
  resumo: "Resumo do laboratório",
};

type Props = {
  painel: PainelChave;
  organizationId: string;
  organizationName: string;
  prazo: PrazoDoLaboratorio;
  abrindo: boolean;
  onAbrirNaOrganizacao: () => void;
};

/**
 * O painel aberto abaixo dos cartões: age na organização escolhida sem trocar a ativa. A faixa do
 * topo existe pra ninguém cadastrar paciente na clínica errada achando que está na outra.
 */
export function PainelDaOrganizacao({ painel, organizationId, organizationName, prazo, abrindo, onAbrirNaOrganizacao }: Props) {
  return (
    <section className="overflow-hidden rounded-xl border border-zinc-200 bg-white shadow-sm dark:border-border dark:bg-card">
      <div className="flex items-center gap-2 border-b border-brand-100 bg-brand-50 px-4 py-2.5 dark:border-primary/20 dark:bg-primary/10">
        <Building2 className="h-4 w-4 shrink-0 text-brand-700 dark:text-primary" />
        <p className="min-w-0 truncate text-[13px] text-brand-800 dark:text-primary">
          <span className="font-semibold">{TITULO[painel]}</span> · você está agindo em{" "}
          <span className="font-semibold">{organizationName}</span>
        </p>
      </div>

      <div className="p-4">
        <OrganizacaoEmFoco key={organizationId} organizationId={organizationId}>
          {painel === "equipe" ? (
            <PainelEquipe />
          ) : painel === "pacientes" ? (
            <PainelPacientes />
          ) : painel === "agenda" ? (
            <PainelAgenda />
          ) : painel === "protese" ? (
            <PainelProtese />
          ) : (
            <PainelPedidosDoLab filtro={painel} prazo={prazo} />
          )}
        </OrganizacaoEmFoco>
      </div>

      <div className="flex justify-end border-t border-zinc-100 px-4 py-3 dark:border-border">
        <button
          type="button"
          onClick={onAbrirNaOrganizacao}
          disabled={abrindo}
          className="inline-flex h-9 items-center gap-1.5 rounded-md border border-zinc-200 bg-white px-3 text-[13px] font-semibold text-zinc-800 transition-colors hover:bg-zinc-50 disabled:opacity-60 dark:border-border dark:bg-card dark:text-foreground dark:hover:bg-muted"
        >
          {abrindo && <Loader2 className="h-3.5 w-3.5 animate-spin" />}
          Abrir em {organizationName}
          <ArrowRight className="h-4 w-4" />
        </button>
      </div>
    </section>
  );
}
